var Shopify = Shopify || {};


Shopify.formatMoney = function(cents, format) {
  if (typeof cents == 'string') { cents = cents.replace('.',''); }
  var value = '';
  var placeholderRegex = /\{\{\s*(\w+)\s*\}\}/;
  var formatString = (format || this.money_format);

  function defaultOption(opt, def) {
     return (typeof opt == 'undefined' ? def : opt);
  }

  function formatWithDelimiters(number, precision, thousands, decimal) {
    precision = defaultOption(precision, 2);
    thousands = defaultOption(thousands, ',');
    decimal   = defaultOption(decimal, '.');

    if (isNaN(number) || number == null) { return 0; }

    number = (number/100.0).toFixed(precision);

    var parts   = number.split('.'),
        dollars = parts[0].replace(/(\d)(?=(\d\d\d)+(?!\d))/g, '$1' + thousands),
        cents   = parts[1] ? (decimal + parts[1]) : '';

    return dollars + cents;
  }

  switch(formatString.match(placeholderRegex)[1]) {
    case 'amount':
      value = formatWithDelimiters(cents, 2);
      break;
    case 'amount_no_decimals':
      value = formatWithDelimiters(cents, 0);
      break;
    case 'amount_with_comma_separator':
      value = formatWithDelimiters(cents, 2, '.', ',');
      break;
    case 'amount_no_decimals_with_comma_separator':
      value = formatWithDelimiters(cents, 0, '.', ',');
      break;
  }

  return formatString.replace(placeholderRegex, value);
};
function updateSizeForAU(targetSelector) {
  if(currentPath == "au.manieredevoir.com") {
    jQuery(targetSelector).each(function() {
        jQuery(this).text(jQuery(this).text().replace(/UK/g, 'AU'));
        jQuery(this).text(jQuery(this).text().replace(/uk/g, 'au'));
    });
  }
}

$(document).ready(function (e) {
updateSizeForAU('.size_swatch .option_selector');

// head-sticky
$(window).scroll(function () {    
    var scroll = $(window).scrollTop();
    if (scroll >= 20) {
        $(".header-style-one").addClass("head-sticky");
        $(".header").addClass("head-sticky");
    } else {
        $(".header-style-one").removeClass("head-sticky");
        $(".header").removeClass("head-sticky");
    }
 });

var shop_money_format = $('body').attr('data-shop-moneyformat');
addcart()
if(sale_timer == true){
    var current_date = new Date();
    var start_time=Math.ceil((current_date.getTime()+ current_date.getTimezoneOffset())/ 1000);
    var a = new Date(start_time*1000);
    var days = ['Sunday','Monday','Tuesday','Wednesday','Thursday','Friday','Saturday'];
    var dayOfWeek = days[a.getDay()];
    var hours_setup=22;
    if(dayOfWeek=='Sunday'){
      hours_setup=16;
    }else{
      hours_setup=22;
    }
    function datetime_counter(){
    var start = new Date() ;
    var start_time_c=Math.ceil((start.getTime()+ start.getTimezoneOffset())/ 1000);
    var gmttime=checktime(start_time_c);
    var myDate=new Date();

    myDate.setHours(hours_setup);
    myDate.setMinutes(0);

    var end = myDate;
    var timeDiff = Math.abs(end.getTime() - (start.getTime()+ start.getTimezoneOffset()*60000)); // in miliseconds
    var timeDiffInSecond = Math.ceil(timeDiff / 1000);
    var hrs = end.getHours() - start.getHours();
    var min = end.getMinutes() - start.getMinutes();
    var sec = end.getSeconds() - start.getSeconds();

    var hour_carry = 0;
    var minutes_carry = 0;
    if(min < 0){
      min += 60;
      hour_carry += 1;
    }
    hrs = hrs - hour_carry;
    if(sec < 0){
      sec += 60;
      minutes_carry += 1;
    }

    min = min - minutes_carry;
    $('.timmer_span').html(seconds_to_days_hours_mins_secs_str(timeDiffInSecond));
  }

  $(document).ready(function(){
    var i = 0;
    if(dayOfWeek!='Saturday'){
      datetime_counter();
    }
    if(count_down_date){
      live_datetime_counter();
    }
    $(function() {
      if(dayOfWeek!='Saturday'){
        setInterval(datetime_counter, 1000);
      }
      if(count_down_date){
        setInterval(live_datetime_counter, 1000);
      }
    });
  });
  function live_checktime(seconds){ 
    var days     = Math.floor(seconds / (24*60*60));
    seconds -= days    * (24*60*60);
    var hours    = Math.floor(seconds / (60*60));
    seconds -= hours   * (60*60);
    var minutes  = Math.floor(seconds / (60));
    seconds -= minutes * (60);
    return hours+":"+minutes;
  }
  function live_datetime_counter(){
    var start = new Date() ;
    var myDate=new Date(count_down_date);
    var end = myDate;
    var timeDiff = Math.abs(end.getTime() - (start.getTime()+ start.getTimezoneOffset()*60000)); // in miliseconds
    var timeDiffInSecond = Math.ceil(timeDiff / 1000);

    var start_time=Math.ceil((start.getTime()+ start.getTimezoneOffset())/ 1000);
    var gmttime=live_checktime(start_time);
    var hrs = end.getHours() - start.getHours();
    var min = end.getMinutes() - start.getMinutes(); 
    var sec = end.getSeconds() - start.getSeconds();  

    var hour_carry = 0;
    var minutes_carry = 0;
    if(min < 0){
      min += 60;
      hour_carry += 1;
    }
    hrs = hrs - hour_carry;
    if(sec < 0){
      sec += 60;
      minutes_carry += 1;
    }
    min = min - minutes_carry;
    $('.live_timmer_span').html(seconds_to_days_hours_mins_secs_str(timeDiffInSecond));
  }
  function checktime(seconds){ 
    var days     = Math.floor(seconds / (24*60*60));
    seconds -= days    * (24*60*60);
    var hours    = Math.floor(seconds / (60*60));
    seconds -= hours   * (60*60);
    var minutes  = Math.floor(seconds / (60));
    seconds -= minutes * (60);
    return hours+":"+minutes;
  }

  function seconds_to_days_hours_mins_secs_str(seconds){ 
    var days     = Math.floor(seconds / (24*60*60));
    seconds -= days    * (24*60*60);
    var hours    = Math.floor(seconds / (60*60));
    seconds -= hours   * (60*60);
    var minutes  = Math.floor(seconds / (60));
    seconds -= minutes * (60);
    var day_str;
    if(days==1){
      day_str=" Day ";
    }else{
      day_str=" Days ";
    }
    return ((0<days)?(days+day_str):"")+hours+" Hrs "+minutes+" Mins";
  }
}
  
// if($(".two_image_video_slider").length > 0){
//   $('.two_image_video_slider').slick({
//       dots: false,
//       infinite: true,
//       arrows: false,
//       speed: 2000,
//       slidesToShow: 1,
//       slidesToScroll: 1,
//       adaptiveHeight: true,
//       autoplay: true,
//       autoplaySpeed: 6000,
//       responsive: [
//           {
//               breakpoint: 767,
//               settings: {
//                   autoplay: false
//               }
//           }
//       ]
//   });
// }

// mini-cart function
function addcart(){
  $.ajax({
    type: "get",
    url: '/cart.js?t='+Math.random(),
    dataType: "json",
    success: function(data) {
      var mini_cart_html = '';
      var mini_cart_shipping_html = '';
      if (currentPath == "me.manieredevoir.com" ) {
         var mini_cart_shipping_val = $(".min-cart-message .min-cart-free-shipping").attr("data-free-shipping");
         var mini_cart_order_val = $(".min-cart-message .min-cart-min-order").attr("minimum-order-price");
      }else if(currentPath == "sa.manieredevoir.com" || getCookie('selectedCountry') == "SA" ) {
        var mini_cart_shipping_val = $(".min-cart-message .min-cart-free-shipping").attr("data-free-shipping-sa");
        var mini_cart_order_val = $(".min-cart-message .min-cart-min-order").attr("minimum-order-price");
      }else if(currentPath == "ae.manieredevoir.com" || getCookie('selectedCountry') == "AE" ) {
        var mini_cart_shipping_val = $(".min-cart-message .min-cart-free-shipping").attr("data-free-shipping-ae");
        var mini_cart_order_val = $(".min-cart-message .min-cart-min-order").attr("minimum-order-price");
      }else if(currentPath == "kw.manieredevoir.com" || getCookie('selectedCountry') == "KW" ) {
        var mini_cart_shipping_val = $(".min-cart-message .min-cart-free-shipping").attr("data-free-shipping-kw");
        var mini_cart_order_val = $(".min-cart-message .min-cart-min-order").attr("minimum-order-price");
      }else if(currentPath == "qa.manieredevoir.com" || getCookie('selectedCountry') == "QA" ) {
        var mini_cart_shipping_val = $(".min-cart-message .min-cart-free-shipping").attr("data-free-shipping-qa");
        var mini_cart_order_val = $(".min-cart-message .min-cart-min-order").attr("minimum-order-price");
      }else{
        var mini_cart_shipping_val = $(".min-cart-message .min-cart-free-shipping").attr("data-free-shipping");
        var mini_cart_order_val = $(".min-cart-message .min-cart-min-order").attr("minimum-order-price");
      }
      var mini_cart_order_html ='';
      var total_non_sale_price;
      var customMessagesHideShow = '';

       
         $.get('/cart?view=min-cart&t='+Math.random()+'',function(data){
            $('.min-cart-main').html(data);
            updateSizeForAU('.cart-content-meta span');
            if(typeof cookieCurrency !== 'undefined' && cookieCurrency){
              Currency.convertAll(shopCurrency, jQuery('[name=currencies]').val());
            }
          });

      
      
      
      if ($(".cart-page").hasClass("not_add_data")) {
          $(".cart-page").removeClass("not_add_data");
      }else{
        $('.min-cart-main').html('');
        $('.min-cart-main').html(mini_cart_html);
      }

      var currency_rate = parseFloat(Shopify.currency.rate);

      // for free shipping message start ----------------------------------
      if(mini_cart_shipping_val){
        $.get('/cart?view=sale_count',function(data){
            if(data){
              total_non_sale_price = data;
            }else{
              total_non_sale_price = 0;
            }
          var shipping_price_with_currency = mini_cart_shipping_val * currency_rate;

          var validPaths = [
              "sa.manieredevoir.com",
              "ae.manieredevoir.com",
              "kw.manieredevoir.com",
              "qa.manieredevoir.com"
          ];
          if (validPaths.includes(currentPath)) {
              shipping_price_with_currency = Math.floor(shipping_price_with_currency / 100) * 100;
          }
            if (total_non_sale_price != 0 ) {
              if(total_non_sale_price >= shipping_price_with_currency){
                $(".min-cart-message .min-cart-free-success").show();
                $(".min-cart-message .min-cart-custom-message").addClass("hide");
                $(".min-cart-message .min-cart-custom-message").hide();
                $(".min-cart-message .min-cart-free-shipping").hide();
              }else{
                if(total_non_sale_price != '0' ){
                  $(".min-cart-message .min-cart-custom-message").removeClass("hide");
                }
                var mini_cart_remaining = shipping_price_with_currency - total_non_sale_price;
                var current_html = $(".min-cart-message .min-cart-free-shipping").attr('data-val');
                var currentPriceValue = Shopify.formatMoney(mini_cart_remaining,shop_money_format)
                if(currentPath == "sa.manieredevoir.com" || getCookie('selectedCountry') == "SA" ) {
                  var removedZero = currentPriceValue.replace(/(\.00) SR$/, " SR").replace(/\.00$/, "")
                }else if(currentPath == "ae.manieredevoir.com" || getCookie('selectedCountry') == "AE" ) {
                  var removedZero = currentPriceValue.replace(/(\.00) AED$/, " AED").replace(/\.00$/, "")
                }else if(currentPath == "kw.manieredevoir.com" || getCookie('selectedCountry') == "KW" ) {
                  var removedZero = currentPriceValue.replace(/\.00$/, "")
                }else if(currentPath == "qa.manieredevoir.com" || getCookie('selectedCountry') == "QA" ) {
                  var removedZero = currentPriceValue.replace(/\,00/, "")
                }else{
                   var removedZero = currentPriceValue
                }
                // if (validPaths.includes(currentPath)) {
                //      var removedZero = currentPriceValue.replace(/(\.00) SR$/, " SR").replace(/\.00$/, "")
                //     console.log("removedZero", removedZero)
                // }else{
                //   var removedZero = currentPriceValue
                // }
              
                
                mini_cart_shipping_html += '<span class="free_shipping_false">'+current_html.replace("{{amount}}", removedZero )+'</span>';
                // if ($( ".min-cart-main .cart-price-sale" ).length > 0) {
                //   $(".min-cart-message .min-cart-custom-message").show();
                // }else{
                //   $(".min-cart-message .min-cart-custom-message").hide();
                // }
                $(".min-cart-message .min-cart-free-success").hide();
                $(".min-cart-message .min-cart-free-shipping").show();
                $(".min-cart-message .min-cart-free-shipping").html(mini_cart_shipping_html);
              }
            }else{
              $(".min-cart-message .min-cart-free-success, .min-cart-message .min-cart-free-shipping").hide();
            }
        });
      }
      // for free shipping message end    

      // for minimum order pop-up start -------------------------------------------
        if(mini_cart_order_val){

            var order_val_with_currency = mini_cart_order_val * currency_rate;
            var giftcardcount  = 0
            $.each(data.items,function(i,v){
              if (v.handle == "gift-cards") {
                giftcardcount
              }else{
                giftcardcount++
              }
            });
            if(order_val_with_currency > data.total_price){
              var current_html = $(".min-cart-message .min-cart-min-order").attr('data-val');
              mini_cart_order_html += current_html.replace("{{amount}}",Shopify.formatMoney(order_val_with_currency,shop_money_format) );
              $(".min-cart-message .min-cart-min-order").html(mini_cart_order_html);
              $(".min-cart-message .min_order_wrap").show();
              $(".min-cart-message .free_shipping_wrap").hide();
              if (giftcardcount != 0) {
                $(".min-cart-bottom a.min-cart-checkout").addClass("disable_checkout");
                $(".min-cart-min-order").show();
                if ($("body").hasClass("template-cart")) {
                    $(".cart form a.button.cart_page_checkout").addClass("disable_checkout");
                }
              }else{
                $(".min-cart-min-order ").hide();
                $(".min-cart-bottom a.min-cart-checkout").removeClass("disable_checkout");
              }
            }else{
              $(".min-cart-message .min_order_wrap").hide();
              $(".min-cart-message .free_shipping_wrap").show();
              $(".min-cart-bottom a.min-cart-checkout").removeClass("disable_checkout");
              if ($("body").hasClass("template-cart")) {
                    $(".cart form a.button.cart_page_checkout").removeClass("disable_checkout");
              }
            }
            
        }
      // for minimum order pop-up end
      

      if(data.item_count != 0){
        var html2 = '';
        $(".header-right-icon .cart").addClass("active");
        html2 += '<span class="cart-count">'+data.item_count+'</span>';
        setTimeout(function(){
          $(".header-right-icon .cart").removeClass("active");
        },1000);
        $('.header-navigation .cart .cart-count').remove();
        $('.header-right-icon li.cart a .cart-count').remove();
        $('.header-right-icon li.cart a').append(html2);
        $('.header-navigation .cart .header-navigation-name').append(html2);
        
        $('.min-cart-no-items').hide();
        $('.min-cart-main').show();
        $('.min-cart-footer ').show();
        $('.min-cart-bottom ').show();
        $('.min-cart-message').show();
        
      }else{
        $('.header-navigation .cart .cart-count').remove();
        $('.header-right-icon li.cart a .cart-count').remove();
        $('.min-cart-no-items').show();
        $('.min-cart-main').hide();
        $('.min-cart-footer').hide();
        $('.min-cart-bottom').hide();
        $('.min-cart-message').hide();
      }
    },
    complete: function(data){
        var cartTotalHtml = Shopify.formatMoney(data.responseJSON.total_price,shop_money_format)
        if(currentPath == "sa.manieredevoir.com" || getCookie('selectedCountry') == "SA" ) {
          var removedZero = cartTotalHtml.replace(/(\.00) SR$/, " SR").replace(/\.00$/, "")
        }else if(currentPath == "ae.manieredevoir.com" || getCookie('selectedCountry') == "AE" ) {
          var removedZero = cartTotalHtml.replace(/(\.00) AED$/, " AED").replace(/\.00$/, "")
        }else if(currentPath == "kw.manieredevoir.com" || getCookie('selectedCountry') == "KW" ) {
          var removedZero = cartTotalHtml.replace(/\.00$/, "")
        }else if(currentPath == "qa.manieredevoir.com" || getCookie('selectedCountry') == "QA" ) {
          var removedZero = cartTotalHtml.replace(/\,00/, "")
        }else{
           var removedZero = cartTotalHtml
        }
      
        var html1 ='<h5 class="">'+removedZero+'</h5>';
        $('.cart-sub-price .cart-subtotal-price').html(html1);

          if(data.responseJSON.items[0] && data.responseJSON.items[0].product_id != ''){
          var prod_id = data.responseJSON.items[0].product_id;
          var cartItems = {product_id:prod_id,limit: 6};
          var productLikeHtml = '';
          var CDproductLikeHtml = '';
          $.ajax({
            type: "get",
            async: false,
            url: '/recommendations/products.json',
            data: cartItems,
            dataType: "json",
            success: function(data) {
    
              $.each(data.products, function( index, product_item ) {
                var product_title = product_item.title;
                var product_handle = product_item.handle;

                CDproductLikeHtml += '<div class="selected-item"><div class="selected-image"><a href="'+product_item.url+'"><img src="'+product_item.images[0]+'&width=350" alt="'+product_title+'"loading="lazy"></a></div><div class="selected-content"><div class="selected-title"><h6>'+product_item.title+'</h6></div></div></div>';
                if ( index <= 2) {
                  productLikeHtml += '<div class="cart-recommended-col" data-id="'+product_item.id+'" data-variant-id="'+product_item.variants[0].id+'"><div class="cart-recommended-image"><a href="'+product_item.url+'"><img src="'+product_item.images[0]+'" alt="'+product_title+'"></a></div>';
                  productLikeHtml += '<div class="cart-recommended-content"><div class="cart-recommended-price"><span class="">'+Shopify.formatMoney(product_item.price,shop_money_format)+'</span></div>';
                  productLikeHtml += '<form id="product_add" method="post" action="/cart/add" accept-charset="UTF-8" enctype="multipart/form-data" data-xsell-mounted="true"><div class="cart-recommended-listbox"><div class="cart-recommended-value">Add to Bag</div><ul class="cart-recommended-option">';
                  var flag = 0;
                  $.each(product_item.variants,function(i,v){
                    var variantItem = v; 
                    if(v.available){
                      if(flag == 0 ){
                        productLikeHtml += '<li value="'+v.id+'" class="variant-size selected">'+v.options[0]+'</li>';
                      }else{
                        productLikeHtml += '<li value="'+v.id+'" class="variant-size">'+v.options[0]+'</li>';
                      }
                      flag++;
                    }
                  });
                   
                  productLikeHtml += '</ul></div>';
                  productLikeHtml += '<select id="variant-listbox" name="id" class="medium" style="display:none;">';
                  $.each(product_item.variants,function(i,v){
                    if(v.available){
                      productLikeHtml += '<option data-sku="'+v.sku+'" data-inventory-quantity="'+v.inventory_quantity+'" value="'+v.id+'">'+v.option1+'</option>';
                    } 
                  });
                  productLikeHtml +=  '</select></form>';
                  productLikeHtml += '</div></div>';
                }
              });
            },
            complete: function(){
              $('.selected-row').html(CDproductLikeHtml);
              // $('.min-cart-recommended').html(productLikeHtml);
            }
          });
        }
      
    }
  });
}
  
// add cart product page
$('#add').click(function(e) {
  e.preventDefault();
  if($(".swatch").hasClass("selectsize")){
    $("#pleaseselectsize").css("display", "none");
  }else{

    var prodvariantid = $('.product-page-left-sec #variant-listbox').val();
    var quantity_prod = $(this).find('[name="quantity"]').val();
    // Gift card JS Start
    if(window.location.href.indexOf("gift-cards") !== -1){
         if ($("#Recipient-checkbox-template").prop('checked')==true){ 
          $(".err-on, .err-oe, .err-rn, .err-re, .err-rd").hide();
            if ($("#your-name-template").val() == ''){
              $(".err-on").show()
            }else if ($("#your-email-template").val() == '') {
              $(".err-oe").show()
            }else if ($("#Recipient-name-template").val() == '') {
              $(".err-rn").show()
            }else if ($("#Recipient-email-template").val() == '') {
              $(".err-re").show()
            }else if ($("#Recipient-send-on-template").val() == '') {
              $(".err-rd").show()
            }
            var OrdererEmail = $("#your-name-template").val();
            var OrdererName = $("#your-email-template").val();
            var RecipientEmail = $("#Recipient-email-template").val();
            var RecipientName = $("#Recipient-name-template").val();
            var RecipientMessage = $("#Recipient-message-template").val();
            var RecipientSendOn =  $("#Recipient-send-on-template").val().replace("/", "-").replace("/", "-");
            var cartItems = {items: [{id:prodvariantid,quantity: quantity_prod, properties:{"__shopify_send_gift_card_to_recipient": "on", "Message": $("#Recipient-message-template").val(), "Recipient email": $("#Recipient-email-template").val(), "Recipient name": $("#Recipient-name-template").val(), "Send on": RecipientSendOn, "Orderer Name": $("#your-name-template").val(), "Orderer Email": $("#your-email-template").val() }}]};
          }else{
            var cartItems = {items: [{id:prodvariantid,quantity: quantity_prod}]};
          }
      }else{
        if($("#PreOrder").prop('checked') == true){
          var cartItems = {items: [{id:prodvariantid,quantity: quantity_prod, properties:{_pre_order: true}}]};
        }else{
          var cartItems = {items: [{id:prodvariantid,quantity: quantity_prod}]};
        }
      }
     var formNotSubmited = "false"
    // Gift card JS End
    $.ajax({
    type: "post",
    url: "/cart/add.js",
    dataType: "json",
    data: cartItems,
    error: function(xhr, status, error) {
      if(window.location.href.indexOf("gift-cards") !== -1){
        formNotSubmited = "true"
      }else{
        // alert(xhr.responseText);
        var VQTY = "#variant_qty_"+prodvariantid;
        var errorMessage = "Only 1 Available."
        $(".pdp.check-stock-msg").html(errorMessage.replace('1', $(VQTY).html())).addClass("active")
      }
    },
    success: function(data2) {
      if(window.location.href.indexOf("gift-cards") !== -1){
          if ($("#Recipient-checkbox-template").prop('checked')==true){ 
           if ($("#your-name-template").val() == ''){
             $(".err-on").show()
           }else if ($("#your-email-template").val() == '') {
             $(".err-oe").show()
           }else if ($("#Recipient-name-template").val() == '') {
             $(".err-rn").show()
           }else if ($("#Recipient-email-template").val() == '') {
             $(".err-re").show()
           }else if ($("#Recipient-send-on-template").val() == '') {
             $(".err-rd").show()
           }else{
             addcart();
             $(".send_as_gift .err-msg").hide()
             $("#your-name-template, #your-email-template, #Recipient-name-template, #Recipient-email-template, #Recipient-message-template").val('')
             if($(window).width() > 767){
                $(".min-cart").addClass("active");
                $("body").addClass("no-scroll");
                CSWishlistrefreshData();
                $(".cart_tab_link1").trigger('click');
             }
           }
          }else{
            addcart();
             if($(window).width() > 767){
                $(".min-cart").addClass("active");
                $("body").addClass("no-scroll");
                CSWishlistrefreshData();
                $(".cart_tab_link1").trigger('click');
             }
          }
        }else{
          addcart();
          if($(window).width() > 767){
            $(".min-cart").addClass("active");
            $("body").addClass("no-scroll");
            CSWishlistrefreshData();
            $(".cart_tab_link1").trigger('click');
          }
        }
    },
    complete: function() {
        
      },
  });
  }
});


// for add to cart
// $(document).on("click","a.mini-cart-add",function(event){
//   event.preventDefault();
//   $(this).parents(".min-cart-col").addClass("loader_active");
//   var prodvariantid = $(this).parents(".min-cart-col").find('select.recommendation-variant').val();
//   var quantity_prod = $(this).parents(".min-cart-col").find('.cart-content-quantity input').val();
//   var cartItems = {items: [{id:prodvariantid,quantity: quantity_prod}]};

//   $.ajax({
//     type: "post",
//     url: "/cart/add.js",
//     dataType: "json",
//     data: cartItems,
//     error: function(xhr, status, error) {
//       alert(xhr.responseText);
//     },
//     success: function(data2) {
//     },
//     complete: function() {
//       addcart();
//     },
//   });
// });
  
// for remove product from cart
$(document).on("click","a.cart-content-remove",function(event){
  event.preventDefault();
  $(this).parents(".min-cart-col").addClass("loader_active");
  var removevariantid = $(this).parents(".min-cart-col").attr('data-id');
  var variantObject = {};
  variantObject[removevariantid] = 0;
  var jsonObject = {}
  jsonObject['updates'] = variantObject;

  $.ajax({
    type: "post",
    url: "/cart/update.js",
    data: jsonObject,
    dataType: "json",
    success: function(data) {
      addcart();
    }
  }); 
});
  
// for increment of cart
$(document).on("click",".qty-plus.plus",function(event){
  event.preventDefault();
  
  if($(this).parents('.min-cart-main').length){
    $(this).parents(".min-cart-col").addClass("loader_active");
    var prodvariantid = $(this).parents(".min-cart-col").attr('data-id');
    var quantity_prod = 1;
    var cartItems = {items: [{id:prodvariantid,quantity: quantity_prod}]};

     $.ajax({
      type: "post",
      url: "/cart/add.js",
      dataType: "json",
      data: cartItems,
      error: function(xhr, status, error) {
        // alert(xhr.responseText);
        var VQTY = $('.cart-quantity-box input[data-id="'+prodvariantid+'"]').val();
        var errorMessage = "Only 1 Available."
        $('.min-cart-main .min-cart-col[data-id="'+prodvariantid+'"] .check-stock-msg').html(errorMessage.replace('1', VQTY)).addClass("active")
      },
      success: function(data2) {
        addcart();
      },
      complete: function() {
        $(".min-cart-col").removeClass("loader_active");
      },
    });
    
  }else{
    var quantity_prod = parseInt($(this).parents(".min-cart-col").find('.cart-content-quantity input').val()) + 1;
    $(this).parents(".min-cart-col").find('.cart-content-quantity input').val(quantity_prod);
  }
});
  
// for decrement of cart
$(document).on("click",".qty-nag.minus",function(event){
  event.preventDefault();

  if($(this).parents('.min-cart-main').length){
    $(this).parents(".min-cart-col").addClass("loader_active");
    var removevariantid = $(this).parents(".min-cart-col").attr('data-id');
    var quantity_prod = parseInt($(this).parents(".min-cart-col").find('.cart-content-quantity input').val()) - 1;
    var variantObject = {};
    variantObject[removevariantid] = quantity_prod;
    var jsonObject = {}
    jsonObject['updates'] = variantObject;

    $.ajax({
      type: "post",
      url: "/cart/update.js",
      data: jsonObject,
      dataType: "json",
      success: function(data) {
        addcart();
      }
    });
  }else{
    var quantity_prod = parseInt($(this).parents(".min-cart-col").find('.cart-content-quantity input').val()) - 1;
    if(quantity_prod){
      $(this).parents(".min-cart-col").find('.cart-content-quantity input').val(quantity_prod);
    }
  }
});

// for add to cart in outfit // cross-sell grid product page
$(document).on("click",".outfit-product-item #variant-listbox ul li.variant-size, .cross-sell-item #variant-listbox ul li.variant-size",function(e) {
  e.preventDefault();
  var prodvariantid = $(this).attr("value");
  var quantity_prod = 1;
  var cartItems = {items: [{id:prodvariantid,quantity: quantity_prod}]};      
  $.ajax({
    type: "post",
    url: "/cart/add.js",
    dataType: "json",
    data: cartItems,
    error: function(xhr, status, error) {
      // alert(xhr.responseText);
      var VQTY = $('.variant-size[value="'+prodvariantid+'"]').attr("data-vqty");
      var errorMessage = "Only 1 Available."
      $('.variant-size[value="'+prodvariantid+'"]').parents("#product_add").find('.check-stock-msg').html(errorMessage.replace('1', VQTY)).addClass("active")
      // Wishlist only 
      // $('.variant-size[value="'+prodvariantid+'"]').parents(".cross-sell-product-content").find('.check-stock-msg').html(xhr.responseJSON.message).addClass("active")
    },
    success: function(data2) {
      addcart();
      if($(window).width() > 767){
          $(".min-cart").addClass("active");
          $("body").addClass("no-scroll");
          CSWishlistrefreshData();
          $(".cart_tab_link1").trigger('click');
      }
      if ($("body").hasClass("template-cart")) {
          // console.log("product added...")
      }else{
        // $(".min-cart").addClass("active");
        // $("body").addClass("no-scroll");
      }
    },
    complete: function() {
    },
  });
});



// for change image and url on click and hover
$(document).on('mouseenter click', '.color-square-item .main_colors_wrapper .product-alt-colours a', function(e) {
  // e.preventDefault();
  $(this).closest(".color-square-item").find(".color-square-item-href").attr('href', $(this).attr('href'));
  $(this).closest('.color-square-item').find('.color-square-item-image-main').find('img').eq(0).attr('src', $(this).attr('data-img1-src'));
  $(this).closest('.color-square-item').find('.color-square-item-image-main').find('img').eq(1).attr('src', $(this).attr('data-img2-src'));
});

$(document).on('mouseleave', '.color-square-item .main_colors_wrapper .product-alt-colours a', function(e) {
  // e.preventDefault();
  var targetEl = ".hide-"+$(this).closest(".color-square-item").find('.main_colors_wrapper').attr('check-current');
  $(this).closest(".color-square-item").find('.color-square-item-image-main').find('img').eq(0).attr('src', $(this).closest(".color-square-item").find('.main_colors_wrapper .product-alt-colours').find(targetEl).attr('data-img1-src'));
  $(this).closest(".color-square-item").find('.color-square-item-image-main').find('img').eq(1).attr('src', $(this).closest(".color-square-item").find('.main_colors_wrapper .product-alt-colours').find(targetEl).attr('data-img2-src'));
  $(this).closest(".color-square-item").find(".color-square-item-href").attr('href', $(this).closest(".color-square-item").find('.main_colors_wrapper .product-alt-colours').find(targetEl).attr('href'));
});


// Accordion Js
$(".cart-popup #container h2, .template-page h2").click(function() {
  $(this).toggleClass("open-accordion");
  $(this).next('blockquote').toggleClass("highlighted");
});
  
// Search Box
function PosEnd(end) {
    var len = end.value.length;
     
    // Mostly for Web Browsers
    if (end.setSelectionRange) {
        end.focus();
        end.setSelectionRange(len, len);
    } else if (end.createTextRange) {
        var t = end.createTextRange();
        t.collapse(true);
        t.moveEnd('character', len);
        t.moveStart('character', len);
        t.select();
    }
}
$("li.search, .toggol-menu-search").on("click", function (e) {
    e.preventDefault();
    if($("body").hasClass("template-search")){
    }else{
      $("body").addClass("no-scroll");
      $("body").addClass("search-open");
    }
    $(".search-desk-box").addClass("active");
    $(".main-wrapper").addClass("active");
    $(".toggol-menu").removeClass("active");
    setTimeout(function(){
      $('.search-desk-input #Search').trigger('touchstart');
    
      PosEnd(Search);
    },50);
    searchSuggestions();
});
$(".search-desk-close, .search-desk-box .main-overlay, .min-cart .main-overlay, .toggol-menu .main-overlay").on("click", function () {
    $(".search-desk-box").removeClass("active");
    $("body").removeClass("search-open");
    $(".main-wrapper").removeClass("active");
    $(".min-cart").removeClass('active');
    $("body").removeClass("no-scroll");
    if($('.productHandlesByCategory[data-name="newCategory"]').length > 0){
      $('.productHandlesByCategory[data-name="newCategory"]').remove()
      $('.cs-wishlist-wrapper').css('overflow', 'auto');
    }
    CSWishlistrefreshData();
    if($("#csws-create-list").length){
        $("#csws-create-list").removeAttr("disabled");
    }
});
$('.search-desk-input #Search').on('touchstart', function () {
  $(this).focus();
});

// load more function 
var pInfScrLoading = false;
var pInfScrDelay = 100;

function pInfScrExecute() {
  if($(document).height() - 1500 < ($(document).scrollTop() + $(window).height())) {
    var loadingImage;
    var pInfScrNode = $('.collection_load_more_wrapper');
    var pInfScrURL = $('.collection_load_more_wrapper .collection-load-more-button').attr("data-href");
    if(!pInfScrLoading && pInfScrNode.length > 0 && pInfScrURL != '') {
      $.ajax({
        type: 'GET',
        url: pInfScrURL,
        beforeSend: function() {
          pInfScrLoading = true;
          loadingImage = $('.collection-load-more-icon').append('<img src="https://cdn.shopify.com/s/files/1/0630/4261/7558/files/New_Speed.gif?v=1709782912" />');
          $('.collection-load-more-button-container').hide();
        },
        success: function(data) {
          // remove loading feedback
          pInfScrNode.remove();
          var filteredData = $(data).find(".scroll_product").html();
          var load_btn = $(data).find(".collection_load_more_wrapper").html();
          var load_btn_href = $(data).find(".collection-load-more-button").attr('data-href');
          var append_count = $(data).find('.main-product-item').length +1 ;
          $(".scroll_product").append(filteredData);
          $(".collection_load_more_wrapper").empty();
          $(".collection_load_more_wrapper").html(load_btn);				
          pInfScrLoading = false;

          CSWishlistrefreshData();
          initializeSwiperForMobile();

          //Add this function for currency convert on load 11-11-2025 Start
          if(typeof cookieCurrency !== 'undefined' && cookieCurrency){
            Currency.convertAll(shopCurrency, jQuery('[name=currencies]').val());
          }
          //Add this function for currency convert on load 11-11-2025 Over
        },
        dataType: "html"
      });
    }
  }
}

$('body').on('click','.collection-load-more-button',function(){
  setTimeout(function(){ 
  pInfScrExecute(); 
}, pInfScrDelay);
  if( $(document).height() - 1500 > $(document).scrollTop() + $(window).height() ) {
    pInfScrDelay = 100;
  }
});
$('body').on('click','.collection-load-more-button',function(){
  setTimeout(function(){ 
  pInfScrExecute(); 
}, pInfScrDelay);
  if( $(document).height() - 1500 > $(document).scrollTop() + $(window).height() ) {
    pInfScrDelay = 100;
  }
});
});




// for form validation start
$(document).on('keyup', '#create_customer input#first_name,#create_customer input#last_name', function (event) {
      var userinput = $(this).val();
      var pattern = /[^a-zA-Z ]/;
      
      if(!pattern.test(userinput))
      {
          $(this).next(".custom_error").remove();
          if($("#create_customer .custom_error").length == 0){
            $(this).parents("#create_customer").find('.action_bottom input[type="submit"]').removeClass("disabled");
            $(this).parents("#create_customer").find('.action_bottom input[type="submit"]').removeAttr("disabled");
          }
      }else{
          $(this).next(".custom_error").remove();
          $(this).after('<p class="custom_error">Special characters are not allowed.</p>')
          $(this).parents("#create_customer").find('.action_bottom input[type="submit"]').addClass("disabled");
          $(this).parents("#create_customer").find('.action_bottom input[type="submit"]').attr("disabled","disabled");
      }
  });
$(document).on('keyup', '#customer-addresses input[name="address[first_name]"],#customer-addresses input[name="address[last_name]"]', function (event) {
    var userinput = $(this).val();
    var pattern = /[^a-zA-Z ]/;
    
    if(!pattern.test(userinput))
    {
        $(this).next(".custom_error").remove();
        if($("form .custom_error").length == 0){
          $(this).parents("form").find('.action_bottom input[type="submit"]').removeClass("disabled");
          $(this).parents("form").find('.action_bottom input[type="submit"]').removeAttr("disabled");
        }
    }else{
        $(this).next(".custom_error").remove();
        $(this).after('<p class="custom_error">Special characters are not allowed.</p>')
        $(this).parents("form").find('.action_bottom input[type="submit"]').addClass("disabled");
        $(this).parents("form").find('.action_bottom input[type="submit"]').attr("disabled","disabled");
    }
});
$(document).on('keyup', '#customer-addresses input[name="address[address1]"],#customer-addresses input[name="address[address2]"]', function (event) {
    var userinput = $(this).val();
    var pattern = /[^a-zA-Z0-9 ,-/:.]/;
    
    if(!pattern.test(userinput))
    {
        $(this).next(".custom_error").remove();
        if($("form .custom_error").length == 0){
          $(this).parents("form").find('.action_bottom input[type="submit"]').removeClass("disabled");
          $(this).parents("form").find('.action_bottom input[type="submit"]').removeAttr("disabled");
        }
    }else{
        $(this).next(".custom_error").remove();
        $(this).after('<p class="custom_error">Special characters are not allowed.</p>')
        $(this).parents("form").find('.action_bottom input[type="submit"]').addClass("disabled");
        $(this).parents("form").find('.action_bottom input[type="submit"]').attr("disabled","disabled");
    }
});
// for form validation end

function everyTime() {
  if ($(".intl-tel-input.iti-container").length > 0) {
     var x = $(".flag-container").offset();
     var toppx = x.top+6+"px";
     var leftpotion = $(window).width() - $(".om-outer-canvas .om-canvas").width() - 40
          newleftpotion = leftpotion+"px"
      var sidebarvidth = $(".om-outer-canvas .om-canvas").width()
          newsidebarvidth = sidebarvidth+"px";
      $(".iti-mobile .intl-tel-input ul#country-listbox").css("left", newleftpotion);
      $(".iti-mobile .intl-tel-input ul#country-listbox").css("top",toppx);
      $(".iti-mobile .intl-tel-input ul#country-listbox").css("max-width",newsidebarvidth);
      $(".intl-tel-input.iti-container").addClass("active");
  }
}
document.addEventListener("DOMContentLoaded", function () {
    const navItem = document.querySelector('.bfsale-nav > a:not(.active)');

    if (navItem) {
        navItem.click();
    }
});



// show collection in search popup
function collectionSearchresult(selected_vendor) {
  $('.search-collection').hide();
  var query = $('input#Search').val();

  $.ajax({
    url: `/search/suggest?q=${query}&section_id=search-collection`,
    type: 'GET',
    dataType: 'html',
    success: function (response) {

      if (!response) {
        $(".search-collection .desk-result-row").html(`<p class="search-no-result">
        Sorry, Nothing Found For collection
        <strong>"${query}"</strong>
      </p>`);
      $('.search-collection').show();
        return;
      }

      $(".search-collection").empty().append(response);

      const accessoryKeywords = ['accessories','bags','headwear','gloves-mittens','ties-cufflinks','scarfs','scarf','sunglasses','belts','jewellery','lifestyle','hats','gloves','footwear'];

      $('.search-collection-attribute').each(function () {
        const handle = $(this).data('collection-handle');
        if (!handle) return;

        const isAccessory = accessoryKeywords.some(keyword =>
          handle.includes(keyword)
        );

        // MAN TAB
        if (selected_vendor === 'man') {
          if (!handle.startsWith('mens-') || isAccessory) {
            $(this).remove();
          }
        }

        // WOMAN TAB
        else if (selected_vendor === 'woman') {
          if (!handle.startsWith('womens-') || isAccessory) {
            $(this).remove();
          }
        }

        // ACCESSORIES TAB
        else if (selected_vendor === 'accessories') {
          if (!isAccessory) {
            $(this).remove();
          }
        }
      });

      // If nothing left after filtering
      if ($('.search-collection-attribute').length === 0) {
        $(".search-collection .desk-result-row").html(`<p class="search-no-result">
        Sorry, Nothing Found For collection
        <strong>"${query}"</strong>
      </p>`);
      }

      $('.search-collection').show();
    },
    error: function () {
      $(".search-collection").empty();
    }
  });
}


function updateDeliveryContentWithAjax() {

  $.ajax({
    url: '/?section_id=update-delivery-content',
    type: 'GET',
    dataType: 'html',
    success: function (data) {

      var scriptText = $(data).find('script:contains("countryDelivery")').html();
      if (!scriptText) return;

      var match = scriptText.match(/const countryDelivery\s*=\s*(\[[\s\S]*?\]);/);
      if (!match) return;

      var countryDelivery = eval(match[1]);

      // Change this to any country code you want
      var selectedCountry = getCookie('selectedCountry') || Shopify.country ;

      var countryData = countryDelivery.find(function(item) {
        return item.countryCodes.includes(selectedCountry);
      });

      if (!countryData) {
        countryData = countryDelivery.find(function(item) {
          return item.countryCodes.includes('REST OF WORD');
        });
      }

      // Clear existing content
      $('.update-delivery-content').html('');

      if (countryData) {
        $.each(countryData.countryText, function(i, html) {
          $('.update-delivery-content').append(html);
        });
      } 
    }
  });

}

$(document).ready(function () {
  updateDeliveryContentWithAjax();
});
